import React from 'react'

export const ForRouter = Page => {
  return props => (
    <div className={'animated fadeIn'}>
      <Page {...props} />
    </div>
  )
}
